import { render, staticRenderFns } from "./twoPage.vue?vue&type=template&id=8f75be68&"
import script from "./twoPage.vue?vue&type=script&lang=js&"
export * from "./twoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports